<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" style="text-align: center;">
                <img :src="qrCodeDataString" />
            </v-col>  
        </v-row>
        <!-- <v-row>
            <v-col cols="12" sm="12" md="12" style="text-align: center;">
                <template v-if="qrCodeFileString">
                    <img :src="qrCodeFileString" />
                    <div>
                        <button @click="qrCodeFileString = null" style="color: white;">Очистить</button>
                    </div>
                </template>
                <button v-else @click="signFile" style="color: white;">Подписать файл</button>                
            </v-col>
        </v-row> -->
    </div>    
</template>

<script>
import { mapActions } from 'vuex';
import sys from '@/services/system';
import { QRSigningClientCMS } from 'sigex-qr-signing-client';


export default {
    name: "QRAuthPanel",
    props: {
        isActive: {
            type: Boolean,
            default: false
        }
    },
    components: {
    },
    computed: {

    },
    data () {
        return {
            isPendingData: false,
            qrCodeDataString: null,
            qrCodeFileString: null
        }
    },
    methods: {
        ...mapActions('global/auth', ['fetchAuthorizeBySign']),
        async signFile() {
            console.log('signFile');

             // Создаем невидимый input для выбора файла
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            
            // Добавляем обработчик события change для input
            fileInput.addEventListener('change', (event) => {
                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    
                    // Обработчик события загрузки файла
                    reader.onload = async (e) => {
                        //console.log('file', e.target.result, e.target.result.split(',')[1] || e.target.result);

                        const base64String = e.target.result.split(',')[1] || e.target.result;

                        let qrSigner = new QRSigningClientCMS('Запрос на подписание', true);
                        await qrSigner.addDataToSign(['Данные на подпись'], base64String, [], false);
                        let qrCode = await qrSigner.registerQRSinging();

                        this.qrCodeFileString = `data:image/gif;base64,${qrCode}`;

                        let signatures = await qrSigner.getSignatures();

                        this.saveByteArray('data.bin', this.base64ToArrayBuffer(signatures[0]));
                    };
                    
                    reader.readAsDataURL(file);
                }
            });
            
            fileInput.click();       
        },
        base64ToArrayBuffer(base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        saveByteArray(reportName, byte) {
            var blob = new Blob([byte], {type: "application/pdf"});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var fileName = reportName;
            link.download = fileName;
            link.click();
        },
        async qrSign() {
            try 
            {
                let dataToSign = sys.generateUUID();
                let dataToSignBase64 = Buffer.from(dataToSign).toString('base64');

                let qrSigner = new QRSigningClientCMS('Запрос на подписание', true);
                await qrSigner.addDataToSign(['Данные на подпись'], dataToSignBase64, [], false);
                let qrCode = await qrSigner.registerQRSinging();

                this.qrCodeDataString = `data:image/gif;base64,${qrCode}`;

                let signatures = await qrSigner.getSignatures();

                if (!(await this.fetchAuthorizeBySign({ sign: signatures[0], signType: 2, salt: dataToSign, locale: this.$i18n.locale })))
                    this.qrSign();

            } 
            catch (err) 
            {
                console.log(err);
                console.log(err.details);
                this.qrSign();
            }
        }
    },
    watch: {
        isActive: {
            handler: function(value) {
                if(value)  {
                    try 
                    {
                        this.qrSign();
                    } 
                    catch (error) 
                    {
                        console.log(error);
                    }                
                }
            },
            immediate: true
        }
    }
}
</script>